import styled from '@emotion/styled';

export const AlLergiesWrapper = styled.div``;
